import { render, staticRenderFns } from "./SectionPartners.vue?vue&type=template&id=26075561"
import script from "./SectionPartners.vue?vue&type=script&lang=ts"
export * from "./SectionPartners.vue?vue&type=script&lang=ts"
import style0 from "./SectionPartners.vue?vue&type=style&index=0&id=26075561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports